<div class="modal-header">
  <h4 class="modal-title pull-left">{{'GLOBAL.OPERATORS' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form id="OperatorForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-6 form-group">
        <label for="identifiant">{{'GLOBAL.IDENTIFIANT' | translate}}</label>
        <input type="text" id="identifiant" name="identifiant" class="form-control" [(ngModel)]="operatorModif().identifiant" [disabled]="estModif()" #identifiant="ngModel" required />
        @if (identifiant.invalid && (identifiant.dirty || identifiant.touched)) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</div>
        }
      </div>
      <div class="col-md-6 form-group">
        <label for="nom">{{'GLOBAL.NOM' | translate}}</label>
        <input type="text" id="nom" name="nom" class="form-control" [(ngModel)]="operatorModif().nom" #nom="ngModel" required />
        @if (nom.invalid && (nom.dirty || nom.touched)) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</div>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 form-group">
        <label for="roles">Roles</label>
        <div class="dropdown" [class.show]="dropdownOpen()" #dropdownElement>
          <button
            class="btn btn-outline-primary dropdown-toggle"
            type="button"
            id="dropdownRoles"
            (click)="toggleDropdown()"
            aria-haspopup="true"
            [attr.aria-expanded]="dropdownOpen()"
            >
            <!-- {{ selectedRoles().length > 0 ? selectedRoles().join(', ') : 'Select Roles' }} -->
            @if (selectedRoles().length > 0) {
              <span>
                @for (role of selectedRoles(); track role; let isLast = $last) {
                  @if (role != '') {
                    <span>
                      {{ 'OPERATOR_ROLE.' + (role | uppercase) | translate }}{{ isLast ? '' : ', ' }}
                    </span>
                  }
                }
              </span>
            } @else {
              {{ 'OPERATOR_ROLE.SELECT_ROLES' | translate }}
            }
          </button>

          <div class="dropdown-menu" [class.show]="dropdownOpen()" aria-labelledby="dropdownRoles" (click)="$event.stopPropagation()">
            @for (role of roles(); track role) {
              <div class="px-3 py-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [id]="'role-' + role.id"
                    [(ngModel)]="role.selected"
                    name="role-{{ role.id }}"
                    (change)="onRoleChange()"
                    />
                    <label class="form-check-label" [for]="'role-' + role.id">
                      {{ 'OPERATOR_ROLE.' + role.name | translate }}
                    </label>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>


      <div class="btn-toolbar justify-content-between">
        <div class="btn-group" role="group">
          <button type="submit" form="OperatorForm" class="btn btn-outline-success" style="margin-right:10px;">{{'GLOBAL.VALIDER' | translate}}</button>
          @if (estModif()) {
            <button type="button" class="btn btn-danger" (click)="showConfirmSuppr()">{{'GLOBAL.SUPPRIMER' | translate}}</button>
          }
        </div>
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.FERMER' | translate}}</button>
        </div>
      </div>
    </form>
  </div>

  <div bsModal #modalConfirmSuppr="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="custom-overlay"></div>
        <div class="modal-body text-center">
          <p>{{'GLOBAL.CONFIRMATION_SUPPRESSION' | translate}}</p>
          <button type="button" class="btn btn-primary" (click)="delete()">{{'GLOBAL.OUI' | translate}}</button>
          <button type="button" class="btn btn-secondary" (click)="hideConfirmSuppr()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
        </div>
      </div>
    </div>
  </div>

  <div bsModal #modalConfirmCancel="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="custom-overlay"></div>
        <div class="modal-body text-center">
          <p>{{'GLOBAL.CONFIRMATION_ANNULATION' | translate}}</p>
          <button type="button" class="btn btn-primary" (click)="bsModalRef.hide()">{{'GLOBAL.OUI' | translate}}</button>
          <button type="button" class="btn btn-secondary" (click)="hideModalCancel()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
